import { Icon } from "@iconify/react";
import lucideChevronDown from "@iconify-icons/lucide/chevron-down";
import lucideChevronRight from "@iconify-icons/lucide/chevron-right";
import lucideEdit3 from "@iconify-icons/lucide/edit-3";
import lucideTrash from "@iconify-icons/lucide/trash";

const defaultSize = 22;

export function LucideEdit3Icon(props: { size?: number }) {
  const { size = defaultSize } = props;
  return <Icon icon={lucideEdit3} width={size} height={size} aria-hidden />;
}

export function LucideTrashIcon(props: { size?: number }) {
  const { size = defaultSize } = props;
  return <Icon icon={lucideTrash} width={size} height={size} aria-hidden />;
}

export function LucideChevronRightIcon(props: { size?: number }) {
  const { size = defaultSize } = props;
  return (
    <Icon
      icon={lucideChevronRight}
      width={size}
      height={size}
      color="currentColor"
      aria-hidden
    />
  );
}

export function LucideChevronDownIcon(props: { size?: number }) {
  const { size = defaultSize } = props;
  return (
    <Icon
      icon={lucideChevronDown}
      width={size}
      height={size}
      color="currentColor"
      aria-hidden
    />
  );
}
